import React from 'react';
 function UseCase(){
  return(
      <div>
          <h1>UseCase</h1>
      </div>
  );
}
export default UseCase;